import React, { useState, useEffect, useRef } from 'react';
// import { fetchAllPromisedData } from '../../../../common/utils/methods/commonMethods/utilityMethod';
// import { endpoint } from '../../../../common/constant';
// import ALoader from '../../../../common/a-loader';
import { Card, CardBody } from 'reactstrap';
import CscMappingListing from './CscMappingListing';
import AButton from 'views/pages/manage/common/form-fields-mui/AButton';
import ALoader from 'views/pages/manage/common/a-loader';
import { getDropdowns } from './utils';
import { endpoint } from 'views/pages/manage/common/constant';
import { fetchAllPostPromisedData } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import { fetchAllPromisedData } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import { successToast } from 'views/pages/manage/common/utils/methods/toasterFunctions/function';
import { fetchDeletePromisedData } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import { processRowList } from '../constant';
import { updateRequest } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import { getAuditDetails } from '../common';

const CscMapping = ({
    buId,
    selectedTabValue,
    action = 'view',
    setDropdowns
}) => {

    const [rows, setRows] = useState([]);
    const ref = useRef()
    const [loader, setLoader] = useState(false)
    const [dropdowns, setDropdownsData] = useState({})
     const isFirstRender = useRef(true);

    const getCscMappingList = async (dropdownList = dropdowns) => {
        try {
            setLoader(true)
            const url = `${endpoint.cscMapping.get}/${buId}`
            const data = await fetchAllPromisedData(url)
            const rowList = processRowList(data, dropdownList)
            setRows(rowList ?? [])
        }
        catch (err) {
            console.log(err)
        }
        finally {
            setLoader(false)
        }
    }


    // useEffect(() => {
    //     buId && selectedTabValue?.key=='cscMapping' && init();
    // }, [buId, selectedTabValue?.key])

    useEffect(() => {
      if (isFirstRender.current) {
        isFirstRender.current = false;
        if (buId) init(); 
        return;
      }
      if (buId && selectedTabValue?.key === "cscMapping") {
        init();
      }
    }, [buId, selectedTabValue?.key]);

    const init = async () => {
        try {
            setLoader(true)
            const dropdown = await getDropdowns()
            await getCscMappingList(dropdown)

            setDropdownsData(dropdown)
            setDropdowns((prev) => ({ ...prev, ...dropdown }))
        }
        catch (err) {

        }
        finally {
            setLoader(false)
        }
    }

    const createUpdateHandler = async (rowForm) => {
        try {
            setLoader(true);
            const reqObj = updateRequest({
                ...rowForm,
                businessAreaKey: buId
            })
            let url = endpoint.cscMapping.create;
            let method = 'post';

            if (!rowForm?.isNew) {
                url = `${endpoint.cscMapping.update}/${reqObj?.id}`;
                method = 'put'
            }
            const resp = await fetchAllPostPromisedData(url, reqObj, method);
            if (resp?.code === 200) {
                getCscMappingList()
                successToast('Request completed successfully!!!')
                ref.current.stopEditing();
            }
        } catch (err) {
            console.log(err);
        }
        finally {
            setLoader(false)
        }
    }

    const deleteHandler = async (rowData) => {
        try {
            setLoader(true);
            const resp = await fetchDeletePromisedData(
                `${endpoint?.cscMapping?.delete}/${rowData?.id}`
            );
            if (resp?.code === 200) {
                getCscMappingList()
                successToast('Request completed successfully!!!')
                ref.current.stopEditing();
            }
        } catch (err) {
            console.log(err);
        }
        finally {
            setLoader(false)
        }
    };


    if (selectedTabValue?.id !== 6) return null;

    return (
        <>
            <Card className='ml-0'>
                <CardBody>
                    <div className='d-flex justify-content-between mx-2 my-3'>
                        <div className='large-text color-grey-80'>CSC Mapping</div>
                        {action != 'view' &&

                            <AButton
                                variant='primary_filled'
                                onClick={() => ref.current.addNewRow()}
                                size='xs'
                            >
                                + Add Config
                            </AButton>
                        }
                    </div>
                    <div style={{ border: '1px solid #E2E2E2' }}>
                        <CscMappingListing
                            rows={rows}
                            ref={ref}
                            dropdowns={dropdowns}
                            createUpdateHandler={createUpdateHandler}
                            loading={loader}
                            setDropdowns={setDropdownsData}
                            deleteHandler={deleteHandler}
                        />
                    </div>
                    {(action === 'view' || action === 'edit') && rows.length > 0 && getAuditDetails(rows[0].updatedBy, rows[0].updatedOn)}

                </CardBody>

            </Card>
        </>
    );
}

export default CscMapping;